export default "__VITE_ASSET__DnuXB8xo__"